/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-24 14:01:40
 * @LastEditors: limin
 * @LastEditTime: 2021-04-21 13:42:06
 */
import {
  COMMON_SET_TEMP_PARAMS,
  COMMON_SET_SYS_CONFIG,
  COMMON_SET_IS_SHOW_TABBAR,
  COMMON_SEARCH_TEXT,
  COMMON_SET_NAVBAR
} from "../types"; // types目录下的mutations函数的常量名
import { myUtils } from "@/utils";
const ShowList = ["/", "home", "myAddress", "searchAddress"];
const state = {
  temp_params: null, // 存放临时参数
  // systems: {
  //   source : '',
  //   sessionId:'',
  //   userId:'',
  // },
  // config: {
  //   appId: '', // 小程序码
  //   lastPath: ''
  // },
  isShowTabBar: 1,
  searchText: "",
  navbar:{
    title:'',
    leftArrow:true
    //... 扩展属性 用于 navbar组件
  },
  sysCfg: {
    source: "",
    sessionId: "",
    userId: "",
    appId: "", // 小程序码
    lastPath: ""
  }
};

const getters = {
  getTempParams: state => {
    // let clone = null
    // if(state.temp_params){
    //   clone = myUtils.deepClone(state.temp_params)
    //   state.temp_params = null
    // }
    // return clone
    return state.temp_params;
  },
  // systemInfo(state){
  //   return state.systems
  // },
  // systemConfig(state) {
  //   return state.config
  // },
  sysCfg(state) {
    return state.sysCfg;
  },
  isShowTabBar(state) {
    return state.isShowTabBar;
  },
  searchText(state) {
    return state.searchText.trim();
  },
  navbar(state) {
    return state.navbar
  }
};

const mutations = {
  [COMMON_SET_TEMP_PARAMS](state, params) {
    // 第一个参数是state 可以修改state 将请求回来的数据保存在state中
    state.temp_params = params;
  },
  [COMMON_SET_SYS_CONFIG](state, data) {
    state.sysCfg = Object.assign(state.sysCfg, data);
  },
  [COMMON_SET_IS_SHOW_TABBAR](state, path) {
    const status = ShowList.includes(path);
    if (state.isShowTabBar !== status) {
      state.isShowTabBar = status;
      setTimeout(() => {
        window.handleTabBar(Number(status));
      }, 50);
    }
  },
  [COMMON_SEARCH_TEXT](state, data) {
    state.searchText = data;
  },
  [COMMON_SET_NAVBAR](state, navbar) {
    state.navbar = Object.assign(state.navbar, navbar);
  }
};

const actions = {
  setTemp({ commit }, params) {
    commit(COMMON_SET_TEMP_PARAMS, params);
  },
  /**
   * 设置参数 (登录回调,登出回调)
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  setSysConfig({ commit }, data) {
    return new Promise(resolve => {
      commit(COMMON_SET_SYS_CONFIG, data);
      resolve();
    });
  },
  /**
   * 初始化参数 (系统初始化)
   * @param {*} param0
   * @returns
   */
  initSysConfig({ commit }) {
    return new Promise(resolve => {
      const cfg = getId();
      if (!cfg) {
        resolve(null);
      } else {
        commit(COMMON_SET_SYS_CONFIG, cfg);
        resolve(cfg);
      }
    });
  },
  setIsShowTabBar({ commit }, path) {
    commit(COMMON_SET_IS_SHOW_TABBAR, path);
  },
  setSearchText({ commit }, data) {
    commit(COMMON_SEARCH_TEXT, data);
  },
  clearTemp({ commit }) {
    commit(COMMON_SET_TEMP_PARAMS, null);
  },
  setNavbar({ commit }, navbar) {
    commit(COMMON_SET_NAVBAR, navbar);
  }
};

const getId = function() {
  const id = myUtils.getUrlParms("id");
  console.log(id, "id");
  if (!id) {
    console.error("没有id,请重新登录或联系管理员");
    return null;
  }
  const [userId, sessionId, source, lastPath, appId] = id.split("|");
  return { userId, sessionId, source, lastPath, appId };
};

export default {
  namespaced: true, // 添加命名空间
  state,
  getters,
  mutations,
  actions
};
